<template>
    <div class="ps-4 pt-4 pb-5">
        <h2>Marketplace</h2>

        <data-model-templates></data-model-templates>
        <hr>
        <webpage-templates></webpage-templates>
    </div>
</template>

<script>
    import DataModelTemplates from "./DataModelTemplates.vue";
    import WebpageTemplates from "./WebpageTemplates.vue";

    export default {
        name: 'Marketplace',
        components: {
            WebpageTemplates,
            DataModelTemplates
        }
    }
</script>

<style>

</style>
